import api from '@pray/shared/utils/api';

/**
 * Preview a transcript segment by generating audio
 * @param {Object} params
 * @param {string} params.artistId - Artist ID (UUID)
 * @param {string} params.contentId - Content ID (UUID)
 * @param {string} params.locale - Locale code
 * @param {string} params.text - Transcript text to preview
 * @param {string} params.voiceId - Eleven Labs voice ID
 * @returns {Promise<{url: string}>} Audio URL for playback
 */
export async function previewTranscriptPreview({
  artistId = null,
  contentId = null,
  locale = null,
  text = null,
  voiceId = null,
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');
  if (!text) throw Error('Text is required');
  if (!voiceId) throw Error('Voice ID is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/transcripts/preview`;
  const response = await api.executeGetRequest(url, {
    text,
    voice_id: voiceId,
  });

  return response.data;
}
